// src/api/settingsApi.js
import axiosInstance from './axiosConfig';

export const settingsApi = {
  getPublicSettings: async () => {
    try {
      const response = await axiosInstance.get('/settings/public');
      return response.data;
    } catch (error) {
      console.error('Error fetching public settings:', error);
      throw error;
    }
  },

  getSettings: async () => {
    try {
      const response = await axiosInstance.get('/settings');
      return response.data;
    } catch (error) {
      console.error('Error fetching settings:', error);
      throw error;
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await axiosInstance.put('/settings', data);
      return response.data;
    } catch (error) {
      console.error('Error updating settings:', error);
      throw error;
    }
  },

  // ✅ FIXED: Use correct endpoint '/settings/admin/logo' from settings.routes.js
  uploadLogo: async (formData) => {
    try {
      const response = await axiosInstance.post('/settings/admin/logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading logo:', error);
      throw error;
    }
  },

  getAdminSettings: async () => {
    try {
      const response = await axiosInstance.get('/settings/admin');
      return response.data;
    } catch (error) {
      console.error('Error fetching admin settings:', error);
      throw error;
    }
  },

  updateAdminSettings: async (data) => {
    try {
      const response = await axiosInstance.put('/settings/admin', data);
      return response.data;
    } catch (error) {
      console.error('Error updating admin settings:', error);
      throw error;
    }
  },

  getThemeSettings: async () => {
    try {
      const response = await axiosInstance.get('/settings/theme');
      return response.data;
    } catch (error) {
      console.error('Error fetching theme settings:', error);
      throw error;
    }
  },

  updateThemeSettings: async (data) => {
    try {
      const response = await axiosInstance.put('/settings/theme', data);
      return response.data;
    } catch (error) {
      console.error('Error updating theme settings:', error);
      throw error;
    }
  },

  getVendors: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/admin/vendors', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching vendors:', error);
      throw error;
    }
  },

  updateVendorCommission: async (data) => {
    try {
      const response = await axiosInstance.put('/settings/admin/vendor-commission', data);
      return response.data;
    } catch (error) {
      console.error('Error updating vendor commission:', error);
      throw error;
    }
  },

  getSiinqeeSettings: async () => {
    try {
      const response = await axiosInstance.get('/settings/admin/payment');
      return response.data;
    } catch (error) {
      console.error('Error fetching Siinqee settings:', error);
      throw error;
    }
  },

  updateSiinqeeSettings: async (data) => {
    try {
      const response = await axiosInstance.put('/settings/admin/payment', data);
      return response.data;
    } catch (error) {
      console.error('Error updating Siinqee settings:', error);
      throw error;
    }
  },

  getLogisticsPricing: async () => {
    try {
      const response = await axiosInstance.get('/logistics/pricing/active');
      return response.data;
    } catch (error) {
      console.error('Error fetching logistics pricing:', error);
      throw error;
    }
  },

  // ✅ Helper method to get full logo URL
  getFullLogoUrl: (logoPath) => {
    if (!logoPath) return '';
    if (logoPath.startsWith('http://') || logoPath.startsWith('https://')) {
      return logoPath;
    }
    const baseUrl = process.env.REACT_APP_API_URL || 'https://api.vtech-solution.com';
    if (logoPath.startsWith('/')) {
      return `${baseUrl}${logoPath}`;
    }
    return `${baseUrl}/${logoPath}`;
  },

  // ✅ Helper method to check if logo URL is valid
  isValidLogoUrl: (url) => {
    if (!url) return false;
    return url.startsWith('http://') || url.startsWith('https://');
  },
};

export default settingsApi;